import { ClientType } from '@common/model/client/clientType';
import { useMemo } from 'react';
import { typeToTitle } from './const';

type Option = { label: string; value: ClientType };
export const useClientTypeOptions = (): Option[] =>
  useMemo(() => {
    return Object.entries(typeToTitle).map(([value, label]) => ({ value, label }));
  }, []);
